import React from "react";

/**
 * Bloque institucional del cierre de la home.
 *
 * En la home pública el titular del hero ya dice "Marcas para la belleza
 * profesional", así que acá el foco pasa al portafolio y no se repite.
 */
const COPY = {
	client: {
		title: "Marcas para la belleza profesional.",
		text: "Un portafolio especializado en coloración, cuidado capilar, uñas, depilación, herramientas, tijeras y mobiliario."
	},
	public: {
		title: "El portafolio, con la identidad de cada marca.",
		text: "Coloración, cuidado capilar, uñas, depilación, herramientas, tijeras y mobiliario: marcas seleccionadas para el profesional."
	}
};

const Institutional = ({ variant = "client", tone = "white" }) => {

	const copy = COPY[variant] || COPY.client;

	return (
		<section id="belimport" className={ `anchor-target py-16 lg:py-[110px] ${tone === "paper" ? "bg-paper" : "bg-white"}` }>
			<div className="shell grid items-end gap-7 lg:grid-cols-[1.15fr_.85fr] lg:gap-12 xl:gap-20">
				<div>
					<p className="eyebrow">Belimport</p>
					<h2 className="display-2 mt-3.5 max-w-[760px]">{ copy.title }</h2>
				</div>

				<p className="m-0 max-w-[500px] text-base leading-relaxed text-muted lg:pb-1 lg:text-[17px]">
					{ copy.text }
				</p>
			</div>
		</section>
	);
};

export default Institutional;
